<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.qnaManagement") }}</h4>
    </div>
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ qna.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ qna.firstRegrName }}</li>
          <li class="view_date">{{ qna.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
        <div v-if="qna.content" v-html="qna.content" class="view_t"></div>
      </div>

      <!------- 답글 시작 -------------------->
      <div style="margine-left: 10px" v-for="(answer, index) in answers" :key="index">
        <div v-if="answer.parent == answer.groupId" class="view_answer_box">
          <div class="view_top">
            <div class="va_top">
              <p>
                <strong>{{ answer.title }}</strong>
              </p>
              <div class="list_bottom_bt">
                <a
                  @click="deleteMgmtQnaAnswer(answer)"
                  class="btn btn-secondary btn-sm m-1"
                  >{{ $t("common.delete") }}</a
                >
                <button @click="goToEdit(answer)" class="btn btn-primary btn-sm m-1">
                  {{ $t("common.edit") }}
                </button>
                <button
                  @click="addAnswer(answer, index)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.reply") }}
                </button>
              </div>
            </div>
            <ul class="view_info">
              <li class="view_user">{{ answer.firstRegrName }}</li>
              <li class="view_date">{{ answer.firstRegDatetime }}</li>
            </ul>
            <div
              class="view_file"
              v-if="answer.fileList.length > 0 && answer.fileList != null"
            >
              <ul>
                <li>
                  <span>File</span>
                  <a
                    v-for="(file, index) in answer.fileList"
                    :key="index"
                    href="#"
                    @click="downloadFile(file)"
                  >
                    {{ file.fileNm }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-html="answer.content" class="view_t"></div>
        </div>
        <!-- 답글의 답글일 경우  -->
        <div
          v-else
          class="view_answer_box"
          :style="{ 'padding-left': 40 * answer.depth + 'px' }"
        >
          <div class="view_top">
            <div class="va_top">
              <p>
                <strong>{{ answer.title }}</strong>
              </p>
              <div class="list_bottom_bt">
                <a
                  @click="deleteMgmtQnaAnswer(answer)"
                  class="btn btn-secondary btn-sm m-1"
                  >{{ $t("common.delete") }}</a
                >
                <button @click="goToEdit(answer)" class="btn btn-primary btn-sm m-1">
                  {{ $t("common.edit") }}
                </button>
                <button
                  @click="addAnswer(answer, index)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.reply") }}
                </button>
              </div>
            </div>
            <ul class="view_info">
              <li class="view_user">{{ answer.firstRegrName }}</li>
              <li class="view_date">{{ answer.firstRegDatetime }}</li>
            </ul>
            <div
              class="view_file"
              v-if="answer.fileList.length > 0 && answer.fileList != null"
            >
              <ul>
                <li>
                  <span>File</span>
                  <a
                    v-for="(file, index) in answer.fileList"
                    :key="index"
                    href="#"
                    @click="downloadFile(file)"
                  >
                    {{ file.fileNm }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-html="answer.content" class="view_t"></div>
        </div>
      </div>
    </div>
    <!-----------------새로운 답변 Form ---------------------->
    <div v-if="addNewAnswer" class="brick_box">
      <table class="write_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                id="title"
                name="answerTitle"
                v-model="newAnswer.title"
                v-validate="'required'"
                class="form-control text"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.file") }}</th>
            <td>
              <uploader
                :options="options"
                class="uploader-example"
                :autoStart="false"
                :size="10"
                @file-added="filesAdded"
                @file-removed="fileRemoved"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn>Select or drag&drop file</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
              <div class="view_file" v-if="newFiles != null">
                <ul>
                  <li>
                    <span>File</span>
                    <a v-for="(file, index) in newFiles" :key="index" href="#">
                      {{ file.fileNm }}
                      <button @click="deleteFile(file)" class="del_bt">Del</button>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                name="answerContent"
                v-model="newAnswer.content"
                :config="editorConfig"
                v-validate="'required'"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <button
          type="button"
          @click="addNewAnswer = false"
          class="btn btn-secondary btn-md m-1"
        >
          {{ $t("common.cancel") }}
        </button>
        <button type="button" @click="saveAnswer" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
    <div class="list_bottom_bt">
      <a @click="deleteMgmtQna" class="btn btn-secondary btn-lg m-1">{{
        $t("common.delete")
      }}</a>
      <button @click="addAnswer" class="btn btn-primary btn-lg m-1">
        {{ $t("common.writeAnswer") }}
      </button>
      <router-link :to="{ name: 'mgmtQna' }" class="btn btn-outline-dark btn-lg m-1">{{
        $t("common.list")
      }}</router-link>
    </div>
  </section>
</template>

<script>
import { goDownloadFile } from "@/api/file";
import {
  getQna,
  getAnswerFiles,
  deleteMgmtQnaAnswer,
  deleteMgmtQna,
  insertQna,
} from "@/api/qna";
export default {
  data() {
    return {
      qnaAnswer: { qnaFiles: "" },
      qna: "",
      boardId: "",
      showTable: false,
      files: [],
      answers: [],
      answerFiles: [],
      addNewAnswer: false,
      newAnswer: {
        boardId: "",
        fileList: [],
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
        parent: "",
        flag: "I",
        state: "Y",
        seq: 1,
      },
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      options: {
        testChunks: false,
        chunkSize: "10", //Block size
        maxChunkRetries: 3,
      },
      newFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
      ],
      seq: 1,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      // 질문 글
      try {
        this.boardId = this.$route.query.boardId;
        const { data } = await getQna(this.boardId);
        this.qna = data.qna;
        this.files = data.files;
        this.answers = data.answers;
        if (this.answers != null && this.answers.length > 0) {
          this.seq = this.answers[this.answers.length - 1].seq;
          this.newAnswer.seq = parseInt(this.seq) + 1;
        } else {
          this.newAnswer.seq = 1;
        }
      } catch (err) {
        console.log(err);
      }
      // 답변에 대한 파일
      if (this.qna.answerId != null) {
        try {
          const response = await getAnswerFiles(this.qna.answerId);
          this.answerFiles = response.data.files;
        } catch (err) {
          console.log(err);
        }
      }
    },
    // QNA 전체 삭제
    async deleteMgmtQna() {
      if (!confirm(this.$t("alert.deleteQna"))) return;
      try {
        this.qna.boardId = this.boardId;
        this.qna.fileList = this.files;
        const { data } = await deleteMgmtQna(this.qna);
        if (data.status) {
          alert(this.$t("alert.deletedSuccessfully"));
          this.$router.push({ name: "mgmtQna" });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    //답변삭제
    async deleteMgmtQnaAnswer(answer) {
      // child answer 확인
      for (let i = 0; i < this.answers.length; i++) {
        if (answer.boardId == this.answers[i].parent) {
          alert(this.$t("alert.itCantNotBeDeleted"));
          return;
        }
      }
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        const { data } = await deleteMgmtQnaAnswer(answer);
        if (data.status) {
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 새로운 답글 추가
    addAnswer() {
      this.addNewAnswer = true;
    },
    // 답변 저장
    async saveAnswer() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const formData = new FormData();
        console.log(this.newAnswer.seq);
        formData.append("boardId", this.newAnswer.boardId);
        formData.append("parent", this.qna.boardId);
        formData.append("seq", this.newAnswer.seq);
        formData.append("title", this.newAnswer.title);
        formData.append("flag", this.newAnswer.flag);
        formData.append("seq", this.newAnswer.seq);
        formData.append("state", this.newAnswer.state);
        if (this.newAnswer.answerContent != null) {
          formData.append("content", this.newAnswer.content);
        } else {
          formData.append("content", this.newAnswer.content);
        }
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("qnaFiles", file);
          }
        }
        const { data } = await insertQna(formData);
        if (data.fileMessage != null && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == null && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.fetchData();
          //   this.$router.push({ name: "mgmtQnaView", params: { boardId: this.boardId } });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
      this.addNewAnswer = false;
    },
    goToEdit(answer) {
      this.newAnswer = answer;
      this.newAnswer.flag = "U";
      this.newFiles = answer.fileList;
      this.addNewAnswer = true;
    },
    async downloadFile(file) {
      try {
        const res = await goDownloadFile(file.fileId);
        let data = res.data;
        if (!data) {
          return;
        }
        const blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) {
          // compatible IE10
          navigator.msSaveBlob(blob, file.fileId);
        } else {
          // IE core support other non-H5 browsers
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file.fileNm);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 파일 추가
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    // 파일 삭제
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
  },
};
</script>

<style></style>
